<template>
  <div :class="bem()">
    <ul :class="bem('list')">
      <li
        v-if="
          (customisedProduct.isInStock ||
            customisedProduct.preorderPartSelected) &&
          !props.showRegisterInterestForm
        "
      >
        <ClientOnly>
          <ShippingConvincer :customised-product="props.customisedProduct" />
          <template #fallback>
            <div
              :class="[bem('delivery-wrapper'), 'vision-shimmer']"
              :style="{ width: '100%', height: '40px' }"
            />
          </template>
        </ClientOnly>
      </li>
      
      <template v-if="showReturnsMessaging">
        <li v-if="customisedProduct.isCustom">
          <CustomNoReturnsWarning />
        </li>
        <li v-else>
          <ReturnsConvincer />
        </li>
      </template>
      
      <li>
        <GuaranteeConvincer />
      </li>
    </ul>
  </div>
</template>

<script setup>
import { ClientOnly } from '#components'

const bem = useBEM('ValueProposition')

const { $i18n } = useNuxtApp()
const globalConfigStore = useGlobalConfigStore()
const showReturnsMessaging = computed(() => {
  const enabledLocales = (globalConfigStore.getConfig('returns-enabled-locales') || '').split(',').map(
    (locale) => locale.trim()
  ).filter(Boolean)
  const currentLocale = $i18n.locale.value
  return enabledLocales.includes(currentLocale) || enabledLocales.includes('all')
})

const props = defineProps({
  customisedProduct: {
    type: Object,
    default: () => ({}),
  },
  showRegisterInterestForm: {
    type: Boolean,
    default: false,
  }
})
</script>

<style lang="postcss" scoped>
.ValueProposition {
  @apply rounded-md border border-grey-400;
}

.ValueProposition__list {
  @apply smMax:flex smMax:flex-col md:grid;

  @screen md {
    grid-auto-rows: 1fr;
  }

  li {
    @apply border-b border-grey-400
      px-4 py-3
      flex items-center
      w-full;

    &:last-child {
      @apply border-none;
    }
  }
}

.ValueProposition__delivery-wrapper {
  @apply rounded;
}
</style>
